import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Box,
  Heading,
  Text,
  Input,
  Button,
  VStack,
  FormControl,
  FormLabel,
  useColorModeValue,
  Container,
} from "@chakra-ui/react";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  /* 
  useEffect(() => {
    console.log('Auth State:', { isAuthenticated, user });
    if (isAuthenticated && user) {
      console.log('User is authenticated, redirecting...');
      switch (user.role) {
        case 'admin':
          navigate('/admin/admin-dashboard');
          break;
        case 'superadmin':
          navigate('/admin/dashboard');
          break;
        default:
          navigate('/user/dashboard');
      }
    }
  }, [isAuthenticated, user, navigate]);
  */

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      console.log("Attempting login with:", formData);
      const result = await login(formData);
      console.log("Login result:", result);

      if (result?.user) {
        toast.success("Login successful!");
        // Navigation will be handled by the useEffect hook
      } else {
        toast.error("Login failed: No user data received");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error?.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Container
      maxW="lg"
      py={{ base: "12", md: "24" }}
      px={{ base: "0", sm: "8" }}
    >
      <Box
        py={{ base: "0", sm: "8" }}
        px={{ base: "4", sm: "10" }}
        bg={bgColor}
        boxShadow={{ base: "none", sm: "md" }}
        borderRadius={{ base: "none", sm: "xl" }}
        borderWidth="1px"
        borderColor={borderColor}
      >
        <VStack spacing="6">
          <Heading size="lg">Welcome Back</Heading>
          <Text color="gray.600">Please sign in to your account</Text>

          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <VStack spacing="5" width="100%">
              <FormControl isRequired>
                <FormLabel>Email</FormLabel>
                <Input
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Password</FormLabel>
                <Input
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                />
              </FormControl>

              <Button
                type="submit"
                colorScheme="blue"
                width="100%"
                isLoading={loading}
                loadingText="Signing in..."
              >
                Sign In
              </Button>
            </VStack>
          </form>
        </VStack>
      </Box>
    </Container>
  );
};

export default Login;
